import React from 'react';
import styled from 'styled-components';

import Modal from 'react-responsive-modal';

import type { IPopup } from './types';

const closeButtonDefault = {
  right: '34px',
};

const Popup = ({
  children,
  height,
  width,
  closeButtonStyles,
  styles,
  ...rest
}: IPopup): JSX.Element => {
  const closeButton = closeButtonStyles || closeButtonDefault;

  return (
    <>
      {/** TODO: @see https://tracker.yandex.ru/LT-39577 */}
      {/** @ts-ignore */}
      <Modal
        styles={{ modal: { height, width }, closeButton, ...styles }}
        {...rest}
      >
        <StyledContent>{children}</StyledContent>
      </Modal>
    </>
  );
};

const StyledContent = styled.div`
  max-height: inherit;
  height: 100%;
  -webkit-overflow-scrolling: touch;
`;

export default Popup;
